import { render, staticRenderFns } from "./editcustomershop.vue?vue&type=template&id=96330e4c"
import script from "./editcustomershop.vue?vue&type=script&lang=js"
export * from "./editcustomershop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports